import { render, staticRenderFns } from "./AdherenceIndicatorsFooter.vue?vue&type=template&id=61653390&scoped=true&"
import script from "./AdherenceIndicatorsFooter.vue?vue&type=script&lang=js&"
export * from "./AdherenceIndicatorsFooter.vue?vue&type=script&lang=js&"
import style0 from "./AdherenceIndicatorsFooter.vue?vue&type=style&index=0&id=61653390&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61653390",
  null
  
)

export default component.exports